module.exports = __webpack_public_path__ + "img/pic01@2x.1217a06e.png";